export default __webpack_public_path__ + "static/media/0041.145188ac.png";